var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatTabActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 2.73535H7C4.24 2.73535 2 4.96535 2 7.71535V13.6954V14.6954C2 17.4454 4.24 19.6754 7 19.6754H8.5C8.77 19.6754 9.13 19.8554 9.3 20.0754L10.8 22.0654C11.46 22.9454 12.54 22.9454 13.2 22.0654L14.7 20.0754C14.89 19.8254 15.19 19.6754 15.5 19.6754H17C19.76 19.6754 22 17.4454 22 14.6954V7.71535C22 4.96535 19.76 2.73535 17 2.73535ZM13 14.4854H7C6.59 14.4854 6.25 14.1454 6.25 13.7354C6.25 13.3254 6.59 12.9854 7 12.9854H13C13.41 12.9854 13.75 13.3254 13.75 13.7354C13.75 14.1454 13.41 14.4854 13 14.4854ZM17 9.48535H7C6.59 9.48535 6.25 9.14535 6.25 8.73535C6.25 8.32535 6.59 7.98535 7 7.98535H17C17.41 7.98535 17.75 8.32535 17.75 8.73535C17.75 9.14535 17.41 9.48535 17 9.48535Z",
    fill: "#6374FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatTabActive);
export default __webpack_public_path__ + "static/media/chat_tab_active.1d7955f4c266278b91de915139e5e3c8.svg";
export { ForwardRef as ReactComponent };